<template>
  <section class="wrapper">
    <div class="content">
      <div class="header-container">
      <div class="header">
        <div class="logo">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable mx-auto"
            alt
          />
        </div>
      </div>
      
      <div class="header-top">
        <p
          class=""
          :class="{
            'header-title': !getFromLogin && !getRegisterPassportAcc,
            'header-title-login': getFromLogin || getRegisterPassportAcc,
          }"
        >
          {{
            getFromLogin || getRegisterPassportAcc
              ? $t('preRegisteration.passportAccount').toUpperCase()
              : $t('common.register').toUpperCase()
          }}
        </p>

      </div>

      <div class="subtitle">{{ $t('preRegisteration.add_photo') }}</div>

    </div>

      <!-- user img  -->
      <div
        class="user-img"
        v-if="!showOptions"
        @click="
          showOptions = true;
          imageToDisplay = null;
          invalidImage = false;
        "
      >
        <div :class="invalidImage ? 'overlay new-invalid-value' : 'overlay'">
          <label for="fileInput" slot="upload-label">
            <div class="d-flex align-items-center">
              <b-avatar
                v-if="!imgSpinner"
                :variant="imageToDisplay ? 'secondary' : 'newlight'"
                class="user-avatar"
                :src="imageToDisplay"
                ><svg
                  v-if="!imageToDisplay"
                  class="camera-icon"
                  width="31"
                  height="26"
                  viewBox="0 0 31 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.65"
                    d="M10.9832 0.769531L9.30717 4.14354H3.02192C1.6291 4.14354 0.507812 5.27212 0.507812 6.67404V22.7006C0.507812 24.1025 1.6291 25.2311 3.02192 25.2311H28.1629C29.5558 25.2311 30.677 24.1025 30.677 22.7006V6.67404C30.677 5.27212 29.5558 4.14354 28.1629 4.14354H21.8777L20.2016 0.769531H10.9832ZM15.5924 8.36104C19.0637 8.36104 21.8777 11.1934 21.8777 14.6873C21.8777 18.1812 19.0637 21.0136 15.5924 21.0136C12.1212 21.0136 9.30717 18.1812 9.30717 14.6873C9.30717 11.1934 12.1212 8.36104 15.5924 8.36104Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </b-avatar>
              <b-spinner
                class="spinner-grow"
                v-else
                type="grow"
                variant="primary"
                role="status"
              ></b-spinner>
              <i class="mdi mdi-camera upload-icon"></i>
            </div>
          </label>
        </div>
      </div>

      <div id="app" class="web-camera-container" v-if="showOptions">
        <div class="camera-button" v-if="!isCameraOpen">
          <div class="is-rounded1" @click="toggleCamera">
            <div style="cursor: pointer">
              <div class="camer-logo-icon">
                <svg
                  width="31"
                  height="25"
                  viewBox="0 0 31 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.4754 0L8.79936 3.37401H2.5141C1.12129 3.37401 0 4.50259 0 5.90451V21.931C0 23.3329 1.12129 24.4615 2.5141 24.4615H27.6551C29.0479 24.4615 30.1692 23.3329 30.1692 21.931V5.90451C30.1692 4.50259 29.0479 3.37401 27.6551 3.37401H21.3699L19.6938 0H10.4754ZM15.0846 7.59151C18.5559 7.59151 21.3699 10.4239 21.3699 13.9178C21.3699 17.4116 18.5559 20.244 15.0846 20.244C11.6134 20.244 8.79936 17.4116 8.79936 13.9178C8.79936 10.4239 11.6134 7.59151 15.0846 7.59151Z"
                    fill="#4A4A4A"
                  />
                </svg>
              </div>
              <div class="take-photo">{{ $t('preRegisteration.take_photo')}}</div>
            </div>
          </div>
          <div class="betwen-line"></div>
          <div class="is-rounded" @click="openUpload()">
            <div style="cursor: pointer">
              <div class="camer-logo-icon">
                <svg
                  width="31"
                  height="24"
                  viewBox="0 0 31 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.98 8.88C14.42 8.79 14.42 3.58 17.98 3.49C21.53 3.58 21.54 8.79 17.98 8.88ZM30.02 2.65V21.24C30.02 22.7 28.83 23.89 27.37 23.89H2.65C1.19 23.89 0 22.7 0 21.24V2.65C0 1.19 1.19 0 2.65 0H27.36C28.82 0 30.01 1.19 30.01 2.65H30.02ZM28.25 2.65C28.25 2.16 27.85 1.77 27.37 1.77H2.65C2.16 1.77 1.77 2.17 1.77 2.65V13.89L6.73 9.93C8.18 9.07 9.66 7.7 12.12 9.93L16.17 13.63L18.87 11.68C21.72 9.49 22.75 10.58 24.02 11.27L28.24 14.25V2.65H28.25Z"
                    fill="#4A4A4A"
                  />
                </svg>
              </div>
              <div class="take-photo">{{ $t('preRegisteration.pick_from_gallery') }}</div>
            </div>
          </div>
        </div>

        <div class="valid-msg" v-if="!invalidImage && !isCameraOpen">
          <p>
            {{ $t('preRegisteration.image_requirements')}}
          </p>
        </div>

        <div v-show="isCameraOpen && isLoading" class="camera-loading">
          <ul class="loader-circle">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>

        <div
          v-if="isCameraOpen"
          v-show="!isLoading"
          class="camera-box"
          :class="{ flash: isShotPhoto }"
        >
          <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

          <video
            v-show="!isPhotoTaken"
            ref="camera"
            :width="258"
            :height="192"
            autoplay
          ></video>

          <canvas
            style="display: none"
            id="photoTaken"
            ref="canvas"
            :width="450"
            :height="337.5"
          ></canvas>
          <img v-if="isPhotoTaken" :src="canvas" alt="" />
        </div>

        <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
          <button
            v-if="isCameraOpen"
            type="button"
            class="back-btn"
            @click="toggleCamera"
          >
            <div>
              <span class="closing-btn"
                ><svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.4611 8.4365H4.73082L11.0375 2.12983L9.43543 0.539062L0.40979 9.5647L9.43543 18.5903L11.0262 16.9996L4.73082 10.6929H18.4611V8.4365Z"
                    fill="white"
                  /></svg
              ></span>
            </div>
          </button>
          <b-button class="upload-btn active-btn capt-btn" @click="takePhoto">
            <span> {{ $t('preRegisteration.capture')}}</span></b-button
          >
        </div>
      </div>

      <p v-if="invalidImage" class="invalid-image">
        {{ $t('preRegisteration.image_upload_error')}}
      </p>

      <b-button
        class="upload-btn active-btn up-btn"
        :class="uploadBtnClasses()"
        :disabled="getLoading || !imageToDisplay || invalidImage"
        v-if="!showOptions"
        @click="
          getLoading = true;
          $emit('next', getDifferentUserType ? 'switch' : '');
        "
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        <span v-else> {{ !!imageToDisplay ? $t('common.next').toUpperCase():$t('common.upload').toUpperCase()}}</span></b-button
      >

      <!-- img upload  -->
      <div class="user-img" style="display: none">
        <div :class="invalidImage ? 'overlay new-invalid-value' : 'overlay'">
          <image-uploader
            outputFormat="verbose"
            :debug="1"
            :maxWidth="4096"
            :maxHeight="2688"
            :quality="0.7"
            :preview="false"
            :autoRotate="true"
            :capture="false"
            accept="image/*"
            @input="handleInput"
            @upload="handleUpload"
            @complete="handleComplete"
          >
            <label
              for="fileInput"
              slot="upload-label"
              id="imgUpload"
              ref="imgUpload"
            >
              <div class="d-flex align-items-center">
                <b-avatar
                  v-if="!imgSpinner"
                  :variant="imageToDisplay ? 'secondary' : 'newlight'"
                  class="user-avatar"
                  :src="imageToDisplay"
                  ><svg
                    v-if="!imageToDisplay"
                    class="camera-icon"
                    width="31"
                    height="26"
                    viewBox="0 0 31 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.65"
                      d="M10.9832 0.769531L9.30717 4.14354H3.02192C1.6291 4.14354 0.507812 5.27212 0.507812 6.67404V22.7006C0.507812 24.1025 1.6291 25.2311 3.02192 25.2311H28.1629C29.5558 25.2311 30.677 24.1025 30.677 22.7006V6.67404C30.677 5.27212 29.5558 4.14354 28.1629 4.14354H21.8777L20.2016 0.769531H10.9832ZM15.5924 8.36104C19.0637 8.36104 21.8777 11.1934 21.8777 14.6873C21.8777 18.1812 19.0637 21.0136 15.5924 21.0136C12.1212 21.0136 9.30717 18.1812 9.30717 14.6873C9.30717 11.1934 12.1212 8.36104 15.5924 8.36104Z"
                      fill="#8C8C8C"
                    />
                  </svg>
                </b-avatar>
                <b-spinner
                  class="spinner-grow"
                  v-else
                  type="grow"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <i class="mdi mdi-camera upload-icon"></i>
              </div>
            </label>
          </image-uploader>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      canvas: null,
      showOptions: false,
      imageToDisplay: null,
      imgSpinner: null,
      invalidImage: false,
      getLoading: false,
      journey_flow_id: null,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",
    };
  },
  watch: {
    imageToDisplay() {
      this.uploadBtnClasses();
    },
    getApiErr(value) {
      if (value) this.getLoading = false;
    },
  },
  computed: {
    ...mapGetters("preRegistration", [
      "getRegisterPassportAcc",
      "getFromLogin",
      "getDifferentUserType",
      "getApiErr",
    ]),
  },
  methods: {
    ...mapActions("preRegistration", ["setImage", "selectRedirectLoader"]),
    openUpload() {
      this.$refs.imgUpload.click();
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.invalidImage = false;
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch(() => {
          this.isLoading = false;
          alert("May the browser didn't support or there is some errors.");
          this.showOptions = true;
          this.invalidImage = false;
          this.isCameraOpen = false;
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
    },

    async takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);

      this.imageToDisplay = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      const blob = await (await fetch(this.imageToDisplay)).blob();
      const file = new File([blob], "imgUploaded.jpg", {
        type: "image/jpeg",
        lastModified: new Date(),
      });
      // URL.createObjectURL(blob)
      // console.log('blob', blob, file);
      this.setImage(file);
      this.toggleCamera();
      this.showOptions = false;
    },

    async handleInput(imgObj) {
      // console.log("input", imgObj);
      const blob = await (await fetch(imgObj.dataUrl)).blob();
      const file = new File([blob], imgObj.info.name, {
        type: imgObj.info.type,
        lastModified: new Date(),
      });
      // console.log('bl', blob, file);
      this.setImage(file);
      // console.log('imgObj', imgObj);
      this.imageToDisplay = imgObj.dataUrl;
      if (
        imgObj.info.orgWidth < 250 ||
        imgObj.info.orgWidth > 4096 ||
        imgObj.info.orgHeight < 300 ||
        imgObj.info.orgHeight > 2688
      ) {
        this.invalidImage = true;
      } else {
        this.invalidImage = false;
      }
      this.showOptions = false;
    },
    handleUpload() {
      console.log("upload");
    },
    handleComplete() {
      console.log("complete");
    },
    uploadBtnClasses() {
      if (this.imageToDisplay && !this.invalidImage) {
        return "active-btn";
      } else if (this.imageToDisplay && this.invalidImage) {
        return "dimmed-btn upload-btn-inv-img";
      } else if (!this.imageToDisplay) {
        return "dimmed-btn ";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container{
  transform: translateY(45px);
  .subtitle {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: rgba(0, 0, 0, 0.28);
    }
}
.header-container > div{
  margin-bottom: 10px;
}
.mdi-before,.mdi-camera::before{
  content: "";
}
.camera-loading {
  overflow: hidden;
  height: 100%;
  //position: absolute;
  width: 100%;
  min-height: 150px;
  margin-top: 3rem;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: -1.2rem;

  ul {
    height: 100%;
    width: 100%;
    z-index: 999999;
    margin: 0;
  }

  .loader-circle {
    display: block;
    height: 14px;
    margin: 0 auto;
    top: 50%;
    inset-inline-start: 100%;
    transform: translateY(-50%);
    transform: translateX(-50%);
    width: 100%;
    padding: 0;

    li {
      display: block;
      float: inline-start;
      width: 10px;
      height: 10px;
      line-height: 10px;
      padding: 0;
      position: relative;
      margin: 0 0 0 4px;
      background: #999;
      animation: preload 1s infinite;
      top: -50%;
      border-radius: 100%;

      &:nth-child(2) {
        animation-delay: 0.2s;
      }

      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }
}
.wrapper {
  .content {
    button.btn.upload-btn.active-btn.up-btn.btn-secondary.disabled.dimmed-btn {
          width: 415px;
          height: 44px;
          margin-inline-start: 0px!important;
           
 
font-weight: 500;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */
border-radius: 22px;
margin-bottom: 40px;
text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #fff;
      }
      button.btn.upload-btn.active-btn.up-btn.btn-secondary {
          width: 415px;
          height: 44px;
          margin-inline-start: 0px!important;
           
 
font-weight: 500;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */
border-radius: 22px;
margin-bottom: 40px;
text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #fff;
      }
    width: 491px;
    background-color: #ffffff;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    margin: 70px auto 50px auto;
    text-align: center;
    position: relative;
    .web-camera-container {
      height: fit-content !important;
      overflow: hidden !important;
      .camera-button {
        display: flex;
        justify-content: center;
      }
      .betwen-line {
        height: 122px !important;
        width: 1px;
        background: #000000;
        opacity: 0.1;
        margin-top: 186px;
      }
      .is-rounded1 {
        width: 145px !important;
        height: 122px !important;
        border-radius: 8px;
        margin-top: 186px;
        background: #f2f2f2;
        padding-top: 33px;
        border-start-end-radius: 0px;
        border-end-end-radius: 0px;
        border-top: none;
        border-bottom: none;
        border-inline-start: none;
      }
      .camer-logo-icon {
        margin-bottom: 20px;
      }
      .take-photo {
         
         
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        opacity: 0.8;
      }
      .is-rounded {
        width: 145px !important;
        height: 122px !important;
        border-radius: 8px;
        margin-top: 186px;
        padding-top: 33px;
        background: #f2f2f2;
        border-inline-end: none;
        border-top: none;
        border-bottom: none;
        border-start-start-radius: 0px;
        border-end-start-radius: 0px;
        &:focus {
          border-inline-end: none;
          border-top: none;
          border-bottom: none;
        }
      }
      .camera-box {
        margin-top: 171px;
        margin-bottom: 37px;
      }
    }
  }
  .header {
    .logo {
      width: 116px;
      height: 22px;
      margin: auto;
      img {
        width: 86px;
        height: 16px;
      }
    }
  }
  .header-top {
    .header-title {
      font-family: "SF Pro Display";
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: #000000;
      text-align: center;
      margin-bottom: unset;
      margin-top:20px;
    }
    .header-title-login {
      font-family: "SF Pro Display";
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: #000000;
      text-align: center;
    }
  }

  .user-img {
    margin-top: 188px;
    margin-bottom: 106px;
    display: flex;
    justify-content: center;
    .overlay {
      transition: opacity 0.5s ease;
      -webkit-transition: opacity 0.5s ease;
      -moz-transition: opacity 0.5s ease;
      position: relative;
      border-radius: 50%;
      width: 108px;
      height: 108px;
      z-index: 1;
      // margin-bottom: 33px;
      &::after {
        content: "\A";
        //position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        top: 0;
        inset-inline-start: 0;
        background: rgba(0, 0, 0, 0.6);
        opacity: 0;
        transition: opacity 0.5s;
        -webkit-transition: opacity 0.5s;
        -moz-transition: opacity 0.5s;
      }
      &:hover {
        &::after {
          opacity: 1;
        }
        .upload-icon {
          display: block;
        }
      }
      div {
        height: 106px;
        .user-avatar,
        .spinner-grow {
          width: 106px;
          height: 106px;
        }
        label {
          margin-bottom: 0px;
        }
      }
    }
  }
  .upload-icon {
    cursor: pointer;
    transition: 0.5s;
    display: none;
    cursor: pointer;
    color: #ffffff;
    opacity: 0.65;
    font-size: 2.5rem;
    //position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    z-index: 3;
    transform: translate(-50%, -50%);
  }
  .valid-msg {
     
     
    font-weight: 700;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
    width: 288px;
    color: #939393;
    margin: auto;
    padding-bottom: 102px;
    padding-top: 21px;
    opacity: 0.8;
  }
  .invalid-image {
     
     
    font-weight: 700;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #f46a6a;
    margin: auto;
    width: 353px;
    padding-bottom: 46px;
    .wrapper .content .user-img .overlay {
      border: solid red 5px;
    }
  }
  .user-avatar {
    background-color: #f2f2f2;
    cursor: pointer;
    .imame-posision {
      z-index: -6;
    }
    .camira-icon {
      //position: absolute;
      top: 50%;
      inset-inline-start: 50%;
      z-index: 9;
    }
  }
  // .invalid-image {
  //   text-align: center;
  //   font-size: 12px;
  //   font-weight: 500;
  //   letter-spacing: 0.25px;
  //   color: #f46a6a;
  //   margin-top: 28px;
  //   margin-bottom: 35px;
  // }
  .camera-shoot {
    display: flex;
    align-items: baseline;
    justify-content: center;
  }
  button.btn.upload-btn.active-btn.capt-btn.btn-secondary{
    height: 44px;
    width: 347px;
    margin-inline-start: 24px;
    border-radius: 22px;
     
    font-size: 16px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #fff;
    // margin-top: 120px;
    margin-bottom: 40px;
  }
  .back-btn {
    width: 44px;
    height: 44px;
    background: #103f5e;
    border-radius: 50%;
    border: none;
  }
  .upload-btn-inv-img {
    margin-top: 0px;
  }
  .active-btn {
    background-color: #103f5e;
    pointer-events: auto;
  }
  .dimmed-btn {
    background-color: #96abb8;
    cursor: not-allowed;
  }
  .custom-file {
    height: 45px;
    width: 130px;
    cursor: pointer;
  }

  .b-avatar-custom {
    position: relative;
  }
}

@media (max-width: 992px) {
  .wizard-tab-container {
    margin-top: -42px;
    .wrapper {
      .content {
        button.btn.upload-btn.active-btn.up-btn.btn-secondary.disabled.dimmed-btn {
          width: 309px;
          height: 37px;
          margin-inline-start: 0px!important;
           
 
font-weight: 500;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */
border-radius: 18px;
margin-bottom: 362px;
text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #fff;
      }
      button.btn.upload-btn.active-btn.up-btn.btn-secondary {
          width: 309px;
          height: 37px;
          margin-inline-start: 0px!important;
           
 
font-weight: 500;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */
border-radius: 18px;
margin-bottom: 362px;
text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #fff;
      }
        width: 360px;
        background-color: #ffffff;
        box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
        border-radius: 0px;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        text-align: center;
        .web-camera-container {
          height: fit-content !important;
          .camera-button {
            display: flex;
            justify-content: center;
          }
          .betwen-line {
            height: 122px !important;
            width: 1px;
            background: #000000;
            opacity: 0.1;
            margin-top: 300px;
          }
          .is-rounded1 {
            width: 145px !important;
            height: 122px !important;
            border-radius: 8px;
            margin-top: 300px;
            background: #f2f2f2;
            padding-top: 33px;
            border-start-end-radius: 0px;
            border-end-end-radius: 0px;
            border-top: none;
            border-bottom: none;
            border-inline-start: none;
          }
          .camer-logo-icon {
            margin-bottom: 20px;
          }
          .take-photo {
             
             
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87);
            opacity: 0.8;
          }
          .is-rounded {
            width: 145px !important;
            height: 122px !important;
            border-radius: 8px;
            margin-top: 300px;
            padding-top: 33px;
            background: #f2f2f2;
            border-inline-end: none;
            border-top: none;
            border-bottom: none;
            border-start-start-radius: 0px;
            border-end-start-radius: 0px;
            &:focus {
              border-inline-end: none;
              border-top: none;
              border-bottom: none;
            }
          }
          .camera-box {
            margin-top: 262px;
            margin-bottom: 48px;
          }
        }
        .header {
          .logo {
            width: 116px;
            height: 22px;
            margin: auto;
            img {
              margin: 73px auto 28px auto;
              width: 116px;
              height: 22px;
            }
          }
        }
        .header-title {
          font-family: "SF Pro Display";
           
          font-weight: 700;
          font-size: 16px;
          line-height: 19px;
          margin-top: 97px !important;
          text-align: center;
          //position: absolute;
          top: 33px;
          inset-inline-start: 39%;
          color: #000000;
          text-align: center;
          margin-bottom: 11px;
        }
        .header-title-login {
          font-family: "SF Pro Display";
           
          font-weight: 700;
          font-size: 16px;
          line-height: 19px;
          margin-top: 97px !important;
          text-align: center;
          //position: absolute;
          top: 33px;
          inset-inline-start: 28%;
          color: #000000;
          text-align: center;
          margin-bottom: 11px;
        }
        .subtitle {
           
           
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          text-align: center;
          //position: absolute;
          top: 180px;
          inset-inline-start: 36%;
          color: rgba(0, 0, 0, 0.28);
        }
        .user-img {
          margin-top: 261px;
          margin-bottom: 48px;
          display: flex;
          justify-content: center;
          .overlay {
            transition: opacity 0.5s ease;
            -webkit-transition: opacity 0.5s ease;
            -moz-transition: opacity 0.5s ease;
            position: relative;
            border-radius: 50%;
            z-index: 1;

            &::after {
              content: "\A";
              //position: absolute;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              top: 0;
              inset-inline-start: 0;
              background: rgba(0, 0, 0, 0.6);
              opacity: 0;
              transition: opacity 0.5s;
              -webkit-transition: opacity 0.5s;
              -moz-transition: opacity 0.5s;
            }
            &:hover {
              &::after {
                opacity: 1;
              }
              .upload-icon {
                display: block;
              }
            }
            div {
              height: 106px;
              .user-avatar,
              .spinner-grow {
                width: 106px;
                height: 106px;
              }
              label {
                margin-bottom: 0px;
              }
            }
          }
        }
        .upload-icon {
          cursor: pointer;
          transition: 0.5s;
          display: none;
          cursor: pointer;
          color: #ffffff;
          opacity: 0.65;
          font-size: 2.5rem;
          //position: absolute;
          top: 50%;
          inset-inline-start: 50%;
          z-index: 3;
          transform: translate(-50%, -50%);
        }
        .valid-msg {
           
           
          font-weight: 700;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #939393;
          padding-top: 16px;
          padding-bottom: 313px;
          width: 266px;
          margin: auto;
          opacity: 0.8;
        }
        .invalid-image {
           
           
          font-weight: 500;
          font-size: 12px;
          line-height: 19px;
          text-align: center;
          letter-spacing: 0.25px;
          width: 307px;
          padding-bottom: 48px;
          color: #f46a6a;
          margin: auto;
        }
        .overlay.new-invalid-value {
          border: solid #f46a6a 1.5px;
        }
        .user-avatar {
          background-color: #f2f2f2;
          cursor: pointer;
          .imame-posision {
            z-index: -6;
          }
          .camira-icon {
            //position: absolute;
            top: 50%;
            inset-inline-start: 50%;
            z-index: 9;
          }
        }
        // .invalid-image {
        //   text-align: center;
        //   font-size: 12px;
        //   font-weight: 500;
        //   letter-spacing: 0.25px;
        //   color: #f46a6a;
        //   margin-top: 28px;
        //   margin-bottom: 35px;
        // }
        button.btn.upload-btn.active-btn.capt-btn.btn-secondary{
          height: 37px;
          width: 253px;
          border-radius: 18.5px;
           
          margin-inline-start: 19px;
          font-size: 16px;
          font-weight: 500;
          line-height: 17px;
          letter-spacing: 0.25px;
          text-align: center;
          color: #fff;

          margin-bottom: 290px;
        }
        .back-btn {
          width: 37px;
          height: 37px;
          background: #103f5e;
          border-radius: 50%;
          border: none;
        }
        .upload-btn-inv-img {
          margin-top: 0px;
        }
        .active-btn {
          background-color: #103f5e;
          pointer-events: auto;
        }
        .dimmed-btn {
          background-color: #96abb8;
          cursor: not-allowed;
        }
        .custom-file {
          height: 45px;
          width: 130px;
          cursor: pointer;
        }

        .b-avatar-custom {
          position: relative;
        }
      }
    }
  }
}
</style>
